module.exports = __webpack_public_path__ + "static/media/win@3x.3723d035.png";